import React, { Component } from "react";
import bgImage from "../../../../../src/img/full-page-bg.png";
import Translation from "../../common/translation/translation.component"
export class RequestHeaders extends Component {
  render() {
    
    return (
      <div className="request-header">
        <img
          className="request-header-bgLogo"
          src={bgImage}
          alt="background-img"
        />
            <h1 className="request-header-title"> <Translation translationKey={this.props.headerTitle} /></h1>
           
      </div>
    );
  }
}
